import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import userRoleService from '../services/UserRole/UserRoleService';

export const getMemberShipByUserId = createAsyncThunk("MemberShipByMailId" , async (payload) => {
    const res = await userRoleService.getMemberShipByUserId(payload);
    return res.data
});


export default getMemberShipByUserId;